import { Autocomplete, IconButton, TextField, Tooltip } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import ReactToPrint from '../../../Shared/print/ReactToPrint';
import { convertDateFormat, today, subtractDays } from '../../../../Js/Date';
import { PosSalesSummeryReportAPI } from './ReportAPI';
import PrintComponentList from "../../SalesNew/SalesReport/TableListPrint"
import { viewShiftAPICall } from '../../../../API/Settings/Shift/viewShiftAPI';


const PosSalesSummery = () => {
  const printRef = useRef();
  const [isShiftTimeWise, setIsShiftTimeWise] = useState(false);

  const userInfo = useSelector((state) => state.loginResponseSlice.value);
  const allBranchesList = useSelector((state) => state.allBranchesSlice.value);
  const allowedBranchList = useSelector((state) => state.allAllowedBranchesSlice.value);
  const decimalPosition = Number(localStorage.getItem("decimalPosition"));
  const { salesSummeryReport } = useSelector((state) => state.posReportshiftSlice);
  const allShiftList = useSelector((state) => state.viewShiftSlice.value);
  console.log(allShiftList);

  // const subtractDays = (date, days) => {
  //     const result = new Date(date);
  //     result.setDate(result.getDate() - days);
  //     return result.toISOString().split("T")[0];
  // };

  const userRole = useSelector((state) => state.userRoleSlice.value);
  const userDefaultBranch = {
    _id: userInfo?.branchPk,
    branchName: userInfo?.branchName
  };

  const formValuesInitial = {
    branch: userRole === "user" ? userDefaultBranch : null,
    // fromDate: subtractDays(today, 10)/\,
    fromDate: "",
    toDate: "",
    shift: null
  };
  useEffect(() => {
    if (userRole === "user" && userDefaultBranch?._id) {
      viewShiftAPICall({ branchId: userDefaultBranch._id });
    }
  }, []);


  const [formValues, setFormValues] = useState(formValuesInitial);
  const [disableShift, setDisableShift] = useState(false);
  const [disableDates, setDisableDates] = useState(false);
  const [validationMsg, setValidationMsg] = useState("");

  const handleInputChange = (key) => (e, newValue) => {
    if (key === "branch") {
      setFormValues((prev) => ({
        ...prev,
        branch: newValue,
        shift: null,
      }));
      setDisableShift(false);
      setDisableDates(false);
      setValidationMsg(""); // ✅ clear on branch change

      if (newValue?._id) {
        viewShiftAPICall({ branchId: newValue._id });
      }
    } else if (key === "shift") {
      setFormValues((prev) => ({
        ...prev,
        shift: newValue,
        fromDate: "",
        toDate: "",
      }));
      setValidationMsg(""); // ✅ clear on shift select

      if (newValue) {
        setDisableDates(true);
        setDisableShift(false);
      } else {
        setDisableDates(false);
      }
    } else if (key === "fromDate" || key === "toDate") {
      const newDateValue = e.target.value;
      setFormValues((prev) => ({
        ...prev,
        [key]: newDateValue,
        shift: null,
      }));
      setValidationMsg(""); // ✅ clear on date change

      if (newDateValue) {
        setDisableShift(true);
      } else {
        setDisableShift(false);
      }
    }
  };


const submitButtonClick = () => {
  setValidationMsg(""); // clear previous messages

  const hasShift = !!formValues?.shift?._id;
  const hasDates = formValues?.fromDate && formValues?.toDate;

  if (!formValues?.branch?._id) {
    setValidationMsg("Please select a branch.");
    return;
  }

  if (!hasShift && !hasDates) {
    setValidationMsg("Please select either a date range or a shift.");
    return;
  }

  let body = {};
  const branchId = formValues?.branch?._id;

  // Helper to get shift time
  const getShiftTimeRange = (shift) => {
    const startTime = shift?.startTime || "00:00:00";
    const endTime = shift?.endTime || "23:59:59";
    return { startTime, endTime };
  };

if (isShiftTimeWise) {
  if (hasShift) {
    const shift = formValues.shift;
    const startDate = `${shift?.startDate} ${shift?.startTime || "00:00:00"}`;
    const endDate = `${shift?.endDate} ${shift?.endTime || "23:59:59"}`;

    body = {
      isTimeWise:isShiftTimeWise,
      branchd: branchId,
      startDate,
      endDate,
      shiftId: shift._id
    };
  } else if (hasDates) {
    // Fall back to using first and last shift for selected dates
    const shiftsForBranch = allShiftList
      .filter((s) => s?.branchId === branchId)
      .sort((a, b) => a?.startTime.localeCompare(b?.startTime));

    const firstShift = shiftsForBranch[0];
    const lastShift = shiftsForBranch[shiftsForBranch.length - 1];

    const startDate = `${formValues?.fromDate} ${firstShift?.startTime || "00:00:00"}`;
    const endDate = `${formValues?.toDate} ${lastShift?.endTime || "23:59:59"}`;

    body = {
      isTimeWise:isShiftTimeWise,

      branchd: branchId,
      startDate,
      endDate,
      shiftId: ""
    };
  }
}
 else {
    // Shift time wise is disabled
    body = {
      isTimeWise:isShiftTimeWise,

      branchd: branchId,
      startDate: formValues?.fromDate ? `${formValues?.fromDate} 00:00:00` : "",
      endDate: formValues?.toDate ? `${formValues?.toDate} 23:59:59` : "",
      shiftId: hasShift ? formValues?.shift?._id : ""
    };
  }

  PosSalesSummeryReportAPI(body); 
};

  // Helper function to process sales data for display
  const processSalesData = (salesTypeWise, aggregatorBreakup) => {
    const mainTypes = ["DINEIN", "DELIVERY", "TAKEAWAY", "RETURN_ORDER"];
    
    // Filter to get only main order types
    // DON'T add aggregators to DELIVERY - they're already included in the backend calculation
    const mainOrders = salesTypeWise?.filter(item => mainTypes.includes(item.ordType)) || [];
    
    return mainOrders;
  };

  // Render sales type wise section
  const renderSalesTypeWise = (data, isPrint = false) => {
    const salesTypeWise = data?.salesTypeWise || [];
    const aggregatorBreakup = data?.aggregatorBreakup || [];
    
    const processedData = processSalesData(salesTypeWise, aggregatorBreakup);
    
    return processedData.map((item, index) => (
      <div key={index}>
        {/* Main order type row */}
        <div style={index % 2 === 0 ? rowWhite : rowLight}>
          <span style={{ width: "11%" }}>{item.ordType}</span>
          <span>{item.count}</span>
          <span>{item.netSales?.toFixed(decimalPosition)}</span>
        </div>
        
        {/* Aggregator breakdown BELOW DELIVERY */}
        {item.ordType === "DELIVERY" && aggregatorBreakup.length > 0 && (
          <>
            {aggregatorBreakup.map((agg, aggIndex) => (
              <div 
                key={`agg-${aggIndex}`} 
                style={{ 
                  display: "flex", 
                  justifyContent: "space-between", 
                  padding: "6px 15px", 
                  paddingLeft: "45px",
                  backgroundColor: "rgb(240 240 240)",
                  fontSize: "0.85em",
                  fontStyle: "italic",
                  color: "#555"
                }}
              >
                <span style={{ width: "11%" }}>↳ {agg.aggregatorName}</span>
                <span>{agg.count}</span>
                <span>{agg.netSales?.toFixed(decimalPosition)}</span>
              </div>
            ))}
          </>
        )}
      </div>
    ));
  };

  return (
    <div className="global-page-parent-container" style={{position:"relative"}}>
      <div
        className="global-white-bg-container Header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0px 30px 0 25px",
          alignItems: "center"
        }}>

        <p>Sales Summery Report</p>
        <div style={{ display: "flex" }}>
          <ReactToPrint
            trigger={(onClick) => (
              <IconButton onClick={onClick} className="printer-div" style={{ padding: "1px" }}>
                <i style={{ color: "white", backgroundColor: " #d787e7", fontSize: "medium", padding: "8px", borderRadius: "2px" }} className="bi bi-printer"></i>
              </IconButton>
            )}
            content={() => printRef?.current || null}
          />

          <Tooltip title="Download">
            <IconButton>
              <i
                className="bi bi-arrow-down-circle"
                style={{
                  backgroundColor: "rgb(255 118 133 / 69%)",
                  color: "white",
                  fontSize: "medium",
                  padding: "8px",
                  borderRadius: "2px"
                }}
              ></i>
            </IconButton>
          </Tooltip>
        </div>
      </div>

      {/* Filters */}
      <div className="global-white-bg-container" style={{ alignItems: "center" }}>
       <div  style={{ display:"flex", alignItems: "center" }}>
        <div className="new-global-single-input auto-complete-new">
          <Autocomplete
            options={userRole === "admin" ? allBranchesList : allowedBranchList || []}
            getOptionLabel={(option) => option?.branchName}
            renderInput={(params) => (
              <TextField {...params} label="Branch" focused variant="outlined" />
            )}
            value={formValues?.branch}
            onChange={handleInputChange("branch")}
          />
        </div>
        <div className="new-global-single-input auto-complete-new">
          <Autocomplete
            options={
              allShiftList?.filter((shift) => shift.branchId === formValues?.branch?._id) || []
            }
            getOptionLabel={(option) => option?.shiftSeq || option?.SHIFID || ""}
            renderInput={(params) => (
              <TextField {...params} label="Shift" focused variant="outlined" />
            )}
            value={formValues?.shift}
            onChange={handleInputChange("shift")}
            disabled={disableShift}
          />

        </div>

        <div className="new-global-single-input" style={{ width: '21%' }}>
          <TextField
            placeholder="From"
            onChange={handleInputChange("fromDate")}
            value={formValues?.fromDate}
            variant="outlined"
            type="date"
            focused
            label="From Date"
            disabled={disableDates}
          />
        </div>

        <div className="new-global-single-input" style={{ width: '21%' }}>
          <TextField
            placeholder="To"
            onChange={handleInputChange("toDate")}
            value={formValues?.toDate}
            variant="outlined"
            type="date"
            focused
            label="To Date"
            disabled={disableDates}
          />
        </div>


        <div style={{ width: "10%" }}>
          <button style={{ width: "100%" }} onClick={submitButtonClick} className="btn btn-primary">
            Submit
          </button>
          {validationMsg && (
            <div style={{ color: "red", marginLeft: "10px", marginTop: "5px" }}>
              {validationMsg}
            </div>
          )}
        </div>
        </div>
 <div className="new-global-single-input" style={{flexDirection:"row" ,margin:"0", display: 'flex', alignItems: 'center', marginLeft: '15px',placeSelf:"flex-end" }}>
      
        <label htmlFor="shiftTimeWise">Shift Time Wise</label>
          <input
          type="checkbox"
          id="shiftTimeWise"
          checked={isShiftTimeWise}
          onChange={(e) => setIsShiftTimeWise(e.target.checked)}
          style={{ marginRight: '8px',flexDirection:"row" }}
        />
      </div>
      </div>
     


      {/* Conditional Report Container */}
      {salesSummeryReport?.data?.length > 0 ? (
        <div
          className="report-scroll-container"
          style={{
            marginTop: '5px',
            padding: '0px 30px 30px 30px',
            backgroundColor: 'white',
            height: 'auto',
            overflowY: 'auto',
            border: '1px solid #e0e0e0',
            borderRadius: '4px',

            // Hide scrollbar
            scrollbarWidth: 'none',       // Firefox
            msOverflowStyle: 'none'       // IE 10+
          }}
        >
          {/* Report Content */}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
            <div>
              <p><strong>Branch:</strong> {salesSummeryReport?.data[0]?.branchName}</p>
              {salesSummeryReport?.data[0]?.shiftNumber && (
                <p><strong>Shift Number:</strong> {salesSummeryReport?.data[0]?.shiftNumber}</p>
              )}
            </div>
            <div style={{ textAlign: 'right' }}>
              {salesSummeryReport?.data[0]?.shiftStartTime && (
                <p><strong>Shift Start:</strong> {new Date(salesSummeryReport?.data[0]?.shiftStartTime).toLocaleString('en-IN', { 
                  day: '2-digit', 
                  month: '2-digit', 
                  year: 'numeric',
                  hour: '2-digit', 
                  minute: '2-digit',
                  hour12: true 
                })}</p>
              )}
              {salesSummeryReport?.data[0]?.shiftEndTime && (
                <p><strong>Shift End:</strong> {new Date(salesSummeryReport?.data[0]?.shiftEndTime).toLocaleString('en-IN', { 
                  day: '2-digit', 
                  month: '2-digit', 
                  year: 'numeric',
                  hour: '2-digit', 
                  minute: '2-digit',
                  hour12: true 
                })}</p>
              )}
              {!salesSummeryReport?.data[0]?.shiftNumber && (
                <>
                  <p><strong>Start Date:</strong> {salesSummeryReport?.data[0]?.startDate?.split(" ")[0]}</p>
                  <p><strong>End Date:</strong> {salesSummeryReport?.data[0]?.endDate?.split(" ")[0]}</p>
                </>
              )}
            </div>
          </div>

          <div style={rowDark}><span>Gross Sales</span><span>{salesSummeryReport?.data[0]?.grossSales?.toFixed(decimalPosition)}</span></div>
          <div style={rowDark}><span>Net Sales</span><span>{salesSummeryReport?.data[0]?.netSales?.toFixed(decimalPosition)}</span></div>
          <div style={rowDark}><span>Total Transaction</span><span>{salesSummeryReport?.data[0]?.paymentDetails?.branchPaymentSummary?.totalTransactions?.toFixed(decimalPosition) || '0.00'}</span></div>
          <div style={rowDark}><span>Average Bill Value</span><span>{salesSummeryReport?.data[0]?.avgBillValue?.toFixed(decimalPosition)}</span></div>
          <div style={rowLight}><span>Wallet</span><span>{salesSummeryReport?.data[0]?.paymentDetails?.wallet?.walletTotal?.toFixed(decimalPosition) || '0.00'}</span></div>
          <div style={rowWhite}><span>Total Gross Receipt</span><span>{(salesSummeryReport?.data[0]?.grossSales + (salesSummeryReport?.data[0]?.paymentDetails?.wallet?.walletTotal || 0))?.toFixed(decimalPosition)}</span></div>
          <div style={rowLight}><span>Total No Of Orders</span><span>{salesSummeryReport?.data[0]?.totalOrders}</span></div>
          <div style={rowWhite}><span>APC (%)</span><span>{salesSummeryReport?.data[0]?.apc?.toFixed(2) || '0.00'}</span></div>
          <div style={rowLight}><span>No Of Paying Customers</span><span>{salesSummeryReport?.data[0]?.payingCustomers || 0}</span></div>
          <div style={rowWhite}><span>No Of Transactions</span><span>{salesSummeryReport?.data[0]?.paymentDetails?.branchPaymentSummary?.totalTransactionCount || 0}</span></div>
          <div style={rowLight}><span>Items Sold</span><span>{salesSummeryReport?.data[0]?.itemsSold || 0}</span></div>
          <div style={rowWhite}><span>No of Refunds</span><span>{salesSummeryReport?.data[0]?.refundCount || 0}</span></div>
          <div style={rowLight}><span>No of Cancels</span><span>{salesSummeryReport?.data[0]?.cancelCount || 0}</span></div>
          
          {/* Delivery Statistics Section */}
          {salesSummeryReport?.data[0]?.deliveryStats?.totalDeliveryCharge > 0 && (
            <div style={{backgroundColor: '#e3f2fd', color: 'black', padding: '6px 15px', display: 'flex', justifyContent: 'space-between', fontSize: '14px', borderLeft: '4px solid #2196f3'}}>
              <span style={{fontWeight: 'bold', color: '#1565c0'}}>Delivery ({salesSummeryReport?.data[0]?.deliveryStats?.deliveryCount || 0} orders | {salesSummeryReport?.data[0]?.deliveryStats?.totalKm?.toFixed(1) || 0} KM)</span>
              <span style={{fontWeight: 'bold', color: '#1565c0'}}>{salesSummeryReport?.data[0]?.deliveryStats?.totalDeliveryCharge?.toFixed(decimalPosition) || 0}</span>
            </div>
          )}
          
          {/* Payment Pending Section */}
          {salesSummeryReport?.data[0]?.pendingOrdersCount > 0 && (
            <div style={{backgroundColor: '#fff3cd', color: 'black', padding: '6px 15px', display: 'flex', justifyContent: 'space-between', fontSize: '14px', borderLeft: '4px solid #ffc107'}}>
              <span style={{fontWeight: 'bold', color: '#856404'}}>Payment Pending ({salesSummeryReport?.data[0]?.pendingOrdersCount} orders)</span>
              <span style={{fontWeight: 'bold', color: '#856404'}}>{salesSummeryReport?.data[0]?.pendingOrdersAmount?.toFixed(decimalPosition)}</span>
            </div>
          )}

          <div>
            <div style={sectionHeader}>
              <span>SALES TYPE WISE BREAKUP DETAILS</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 15px", backgroundColor: "rgb(180 185 195)" }}>
              <span style={{ width: "11%" }}>type</span>
              <span>count</span>
              <span>amount</span>
            </div>

            {renderSalesTypeWise(salesSummeryReport?.data[0])}
          </div>


          <div>
            <div style={sectionHeader}><span>TENDER BREAKUP DETAILS</span></div>
            {salesSummeryReport?.data[0]?.paymentDetails?.tenderBreakeupDetails.map((item, index) => (
              <div key={index} style={index % 2 === 0 ? rowWhite : rowLight}>
                <span>{item.journalName}</span>
                <span>{item.totalAmount?.toFixed(decimalPosition)}</span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div
          style={{
            marginTop: '5px',
            padding: '30px',
            backgroundColor: 'white',
            textAlign: 'center',
            fontSize: '16px',
            color: '#888',
            fontWeight: 'bold',
            border: '1px solid #e0e0e0',
            borderRadius: '4px'
          }}
        >
          No Record Found
        </div>
      )}

      {/* Hidden Print Container */}
      <div className="print-parent" style={{position: 'absolute', left: '-9999px', top: 0}}>
        <div ref={printRef} style={{backgroundColor: 'white', padding: '20px', width: '210mm'}}>
          {salesSummeryReport?.data?.length > 0 ? (
            <>
              {/* Report Header */}
              <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                <h2 style={{ margin: '0 0 10px 0' }}>Sales Summary Report</h2>
              </div>

              {/* Report Content for Print */}
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <div>
                  <p><strong>Branch:</strong> {salesSummeryReport?.data[0]?.branchName}</p>
                  {salesSummeryReport?.data[0]?.shiftNumber && (
                    <p><strong>Shift Number:</strong> {salesSummeryReport?.data[0]?.shiftNumber}</p>
                  )}
                </div>
                <div style={{ textAlign: 'right' }}>
                  {salesSummeryReport?.data[0]?.shiftStartTime && (
                    <p><strong>Shift Start:</strong> {new Date(salesSummeryReport?.data[0]?.shiftStartTime).toLocaleString('en-IN', { 
                      day: '2-digit', 
                      month: '2-digit', 
                      year: 'numeric',
                      hour: '2-digit', 
                      minute: '2-digit',
                      hour12: true 
                    })}</p>
                  )}
                  {salesSummeryReport?.data[0]?.shiftEndTime && (
                    <p><strong>Shift End:</strong> {new Date(salesSummeryReport?.data[0]?.shiftEndTime).toLocaleString('en-IN', { 
                      day: '2-digit', 
                      month: '2-digit', 
                      year: 'numeric',
                      hour: '2-digit', 
                      minute: '2-digit',
                      hour12: true 
                    })}</p>
                  )}
                  {!salesSummeryReport?.data[0]?.shiftNumber && (
                    <>
                      <p><strong>Start Date:</strong> {salesSummeryReport?.data[0]?.startDate?.split(" ")[0]}</p>
                      <p><strong>End Date:</strong> {salesSummeryReport?.data[0]?.endDate?.split(" ")[0]}</p>
                    </>
                  )}
                </div>
              </div>

              <div style={rowDark}><span>Gross Sales</span><span>{salesSummeryReport?.data[0]?.grossSales?.toFixed(decimalPosition)}</span></div>
              <div style={rowDark}><span>Net Sales</span><span>{salesSummeryReport?.data[0]?.netSales?.toFixed(decimalPosition)}</span></div>
              <div style={rowDark}><span>Total Transaction</span><span>{salesSummeryReport?.data[0]?.paymentDetails?.branchPaymentSummary?.totalTransactions?.toFixed(decimalPosition) || '0.00'}</span></div>
              <div style={rowDark}><span>Average Bill Value</span><span>{salesSummeryReport?.data[0]?.avgBillValue?.toFixed(decimalPosition)}</span></div>
              <div style={rowLight}><span>Wallet</span><span>{salesSummeryReport?.data[0]?.paymentDetails?.wallet?.walletTotal?.toFixed(decimalPosition) || '0.00'}</span></div>
              <div style={rowWhite}><span>Total Gross Receipt</span><span>{(salesSummeryReport?.data[0]?.grossSales + (salesSummeryReport?.data[0]?.paymentDetails?.wallet?.walletTotal || 0))?.toFixed(decimalPosition)}</span></div>
              <div style={rowLight}><span>Total No Of Orders</span><span>{salesSummeryReport?.data[0]?.totalOrders}</span></div>
              <div style={rowWhite}><span>APC (%)</span><span>{salesSummeryReport?.data[0]?.apc?.toFixed(2) || '0.00'}</span></div>
              <div style={rowLight}><span>No Of Paying Customers</span><span>{salesSummeryReport?.data[0]?.payingCustomers || 0}</span></div>
              <div style={rowWhite}><span>No Of Transactions</span><span>{salesSummeryReport?.data[0]?.paymentDetails?.branchPaymentSummary?.totalTransactionCount || 0}</span></div>
              <div style={rowLight}><span>Items Sold</span><span>{salesSummeryReport?.data[0]?.itemsSold || 0}</span></div>
              <div style={rowWhite}><span>No of Refunds</span><span>{salesSummeryReport?.data[0]?.refundCount || 0}</span></div>
              <div style={rowLight}><span>No of Cancels</span><span>{salesSummeryReport?.data[0]?.cancelCount || 0}</span></div>
              
              {/* Delivery Statistics Section - Print */}
              {salesSummeryReport?.data[0]?.deliveryStats?.totalDeliveryCharge > 0 && (
                <div style={{backgroundColor: '#e3f2fd', color: 'black', padding: '6px 15px', display: 'flex', justifyContent: 'space-between', fontSize: '14px', borderLeft: '4px solid #2196f3'}}>
                  <span style={{fontWeight: 'bold', color: '#1565c0'}}>Delivery ({salesSummeryReport?.data[0]?.deliveryStats?.deliveryCount || 0} orders | {salesSummeryReport?.data[0]?.deliveryStats?.totalKm?.toFixed(1) || 0} KM)</span>
                  <span style={{fontWeight: 'bold', color: '#1565c0'}}>{salesSummeryReport?.data[0]?.deliveryStats?.totalDeliveryCharge?.toFixed(decimalPosition) || 0}</span>
                </div>
              )}
              
              {/* Payment Pending Section - Print */}
              {salesSummeryReport?.data[0]?.pendingOrdersCount > 0 && (
                <div style={{backgroundColor: '#fff3cd', color: 'black', padding: '6px 15px', display: 'flex', justifyContent: 'space-between', fontSize: '14px', borderLeft: '4px solid #ffc107'}}>
                  <span style={{fontWeight: 'bold', color: '#856404'}}>Payment Pending ({salesSummeryReport?.data[0]?.pendingOrdersCount} orders)</span>
                  <span style={{fontWeight: 'bold', color: '#856404'}}>{salesSummeryReport?.data[0]?.pendingOrdersAmount?.toFixed(decimalPosition)}</span>
                </div>
              )}

              <div>
                <div style={sectionHeader}>
                  <span>SALES TYPE WISE BREAKUP DETAILS</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 15px", backgroundColor: "rgb(180 185 195)" }}>
                  <span style={{ width: "11%" }}>type</span>
                  <span>count</span>
                  <span>amount</span>
                </div>

                {renderSalesTypeWise(salesSummeryReport?.data[0], true)}
              </div>

              <div>
                <div style={sectionHeader}><span>TENDER BREAKUP DETAILS</span></div>
                {salesSummeryReport?.data[0]?.paymentDetails?.tenderBreakeupDetails?.map((item, index) => (
                  <div key={index} style={index % 2 === 0 ? rowWhite : rowLight}>
                    <span>{item.journalName}</span>
                    <span>{item.totalAmount?.toFixed(decimalPosition)}</span>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div style={{ padding: '40px', textAlign: 'center' }}>
              <p>No data available to print. Please submit the form to generate the report.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Style constants
const rowDark = {
  backgroundColor: '#444',
  color: 'white',
  padding: '6px 15px',
  fontWeight: 'bold',
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '14px',
  marginBottom: '5px'
};

const rowWhite = {
  backgroundColor: 'white',
  color: 'black',
  padding: '6px 15px',
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '14px'
};

const rowLight = {
  backgroundColor: 'rgb(227 227 227)',
  color: 'black',
  padding: '6px 15px',
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '14px'
};

const sectionHeader = {
  backgroundColor: '#cfdfff',
  fontWeight: 'bold',
  padding: '10px 15px',
  display: 'flex',
  justifyContent: 'space-between'
};

export default PosSalesSummery;
